import React, { useState } from "react"
import Select from 'react-select';

import API from '../../tools/API';
import style from './Modal.module.scss';
import { SingleSelectedChannel } from '../../tools/interfaces';

interface AddCathegory {
    openModal: (arg: boolean) => void;
    stationList: SingleSelectedChannel[]
}

const AddCathegoryModal: React.FC<AddCathegory> = ({ openModal, stationList }) => {
    const [name, setName] = useState('');
    const [generate, setGenerete] = useState(false);

    const [selectedStation, setSelectedStation] = useState<SingleSelectedChannel | null>(null);
    const [error, setError] = useState<string | null>(null);
    const [loading, setLoading] = useState<boolean>(false);

    const makeNewCathegory = () => {
        if (name && selectedStation && !error) {
            API.postNewCathegory(name, selectedStation.value, generate)
                .then(res => {
                    openModal(false);
                    setLoading(false);
                })
                .catch(err => {
                    setLoading(false);
                    setError(err.response.data.Exception);
                })
        } else {
            setLoading(false);
            setError("Wszystkie pola muszą być uzupełnione!");
        }
    }

    const customStyles = {
        indicatorsContainer: () => ({
            backgroundColor: '#e10626',
            borderRadius: '50%',
            marginLeft: '30px',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center'
        }),
        control: () => ({
            display: 'flex',
            padding: '5px 13px 5px 13px',
            backgroundColor: '#eff1f6',
            border: '1px solid #cacaca',
            borderRadius: '20px',
            fontSize: '18px',
            fontWeight: '500',
            color: '#555454'
        }),
        dropdownIndicator: () => ({
            color: 'white',
            padding: '5px 7px',
            display: 'flex',
            alignItems: 'center',
            cursor: 'pointer'
        }),
        indicatorSeparator: () => ({
            display: 'none'
        })
    }


    return (
        <div className={style.AddCathegory}>
            <h2 className={style.AddCathegory__title} >Dodaj kategorię</h2>
            {stationList &&
                (
                    <form className={style.AddCathegory__form}>
                        <Select
                            className={style.AddCathegory__selector}
                            value={selectedStation}
                            onChange={(e) => {
                                setSelectedStation(e)
                            }}
                            options={stationList}
                            placeholder={"Wybierz stację"}
                            styles={customStyles}
                        />
                        <input
                            type="text"
                            id="cathegoryName"
                            placeholder="Nazwa"
                            className={style.AddCathegory__formInput}
                            value={name}
                            onChange={(e) => {
                                setName(e.target.value)
                            }}
                        />
                        <div className={style.AddCathegory__container}>
                            <label
                                htmlFor="automatGenerate"
                                className={style.AddCathegory__formLabel}
                            >
                                Automatycznie generuj następne głosowanie:
                            </label>
                            <input
                                type="checkbox"
                                id="automatGenerate"
                                name="automatGenerate"
                                className={style.AddCathegory__checkbox}
                                checked={generate}
                                onChange={(e) => {
                                    setGenerete(e.target.checked)
                                }}
                            />
                        </div>
                        {!loading ? <input
                            type="button"
                            value="DODAJ"
                            className={style.AddCathegory__button}
                            onClick={(e) => {
                                e.preventDefault();
                                setLoading(true);
                                makeNewCathegory();
                            }}
                        /> : <p className={style.loader}>Trwa dodawanie...</p>
                        }
                        {error &&
                            <div className={style.addPoll__row}>
                                <p className={style.errorText}>{error}</p>
                            </div>
                        }

                    </form>
                )
            }
        </div>
    )
}

export default AddCathegoryModal 